import BackToTop from '@elem/compCommon/BackToTop';
import { createPortal } from 'react-dom';
import EmailSubscribe, { PAGE_TYPE } from '@elem/compCommon/EmailSubscribe';
import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import F from './components/F';
import F_Next from './components/F_Next';
import G from './components/G';
import { useGlobal } from '@/utils/useGlobal';

export default function IndexDynamic() {
    const { useState, useEffect } = useGlobal();
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <>
            <B />
            <C />
            <D />
            <E />
            <F />
            <F_Next />
            <EmailSubscribe locale="jp" className="email-subscribe" pageType={PAGE_TYPE.HomeBattery} entry_position={10} />
            <G />
            {isClient && createPortal(<BackToTop />, document.body)}
        </>
    );
}
